import WebcamCapture from '../components/WebcamCapture';
import {useConfig} from '../ConfigProvider';
import { Redirect } from "react-router-dom";
import StyledStepFooter from '../StyledStepFooter';
import { useTunnelData } from '../TunnelContext';
import Button from "../Button";
import Step from './Step';
import Api from '../baseApi';
import { useState } from 'react';
import CartSummary from '../CartSummary';

import "./Photo.scss";

/**
 * Différents états associés à cet écran spécifique
 * Conditionne l'affichage de la page
 */
const PHOTO_STEPS = {
    WEBCAM: 'WEBCAM',
    LOADING: 'LOADING',
    NEXT: 'NEXT',
    SEPA: 'SEPA'
};

export default function Photo() {

    const config = useConfig();
    const {tunnel} = useTunnelData();

    const [step, setStep] = useState(PHOTO_STEPS.WEBCAM);
    const [errorMsg, errorMsgSet] = useState(false);
    const [photoTaken, setPhotoTaken] = useState(null);

    const doUploadPhoto = async () => {
        // L'email n'est plus envoyé : après le redirect de paiement, le tunnel rechargé par
        // GET /api/vel/tunnel a ses données personnelles masquées par '###'. C'est vel-api
        // qui relit l'email en base à partir du tunnelUid.
        const tunnelUid = tunnel.uid;
        const clubId = tunnel.club?.msdsId;

        if (!tunnelUid || !clubId) {
            // Sans contexte de tunnel il n'y a rien d'exploitable côté API. On l'affiche au
            // lieu de deviner un club, ce qui envoyait la photo sur le club d'un tiers.
            console.error("Cannot upload photo: missing tunnel uid or club id", {tunnelUid, clubId});
            errorMsgSet("Votre session a expiré, merci de recommencer votre inscription.");
            return;
        }

        setStep(PHOTO_STEPS.LOADING);
        errorMsgSet(false);
        const bodyUploadPhoto = {
            tunnelUid,
            clubId,
            photo: photoTaken,
        };

        try {
            const [query] = Api.POST({
                path: '/api/vel/upload/photo',
                body: bodyUploadPhoto,
            });

            const response = await query;
            if (!response.id || response.id <= 0) {
                throw new Error(response.message || "Erreur: ID de réponse invalide");
            }
            console.info("Photo uploaded successfully!");
            setStep(PHOTO_STEPS.NEXT);

        } catch (error) {
            console.error("Error uploading photo:", error);
            errorMsgSet(error.message || "Une erreur s'est produite lors de l'envoi de la photo, veuillez réessayer.");
            setStep(PHOTO_STEPS.WEBCAM);
        } finally {
            console.log("Upload photo process completed.");
        }
    };

    // Affichage de la page - en fonction de l'état step du component

    switch (step) {
      case PHOTO_STEPS.LOADING:
        return <Step classe="Photo" step="Votre photo" loading={config.loadingTextPhotoUpdate} style={{height:'100vh'}}/>;


      case PHOTO_STEPS.NEXT:
        if (config.photo.step === 'end') {
          return <Redirect push to={'/confirmation'} />
        }

        if (config.plans.beforeUser) {
          if (config.recap) {
            let nextStep = () => setStep(PHOTO_STEPS.SEPA);
            return <CartSummary goNext={ nextStep } errorMsg={errorMsg} errorMsgSet={errorMsgSet}/>;
          }
          else {
            return <Redirect push to={'/sepa'} />;
          }
        }
        else {
          return <Redirect push to={'/plans'} />;
        }


      case PHOTO_STEPS.SEPA:
        return <Redirect push to={'/sepa'} />;

      case PHOTO_STEPS.WEBCAM: default:
        return (
          <Step classe="Photo" step="Votre photo">
            {config.confirmation.tracker && config.confirmation.tracker(tunnel) }
            <section>
              <h2>{config.photo.title}</h2>
              <p>{config.photo.explain}</p>
              <WebcamCapture onPhotoTaken={setPhotoTaken} />
            </section>
            <StyledStepFooter>
              {!!errorMsg && <p style={{textAlign:'center', fontWeight:'bold', marginBottom:'1rem'}}>{errorMsg}</p>}
              <Button variant='primary' disabled={!photoTaken} onClick={doUploadPhoto}>{config.photo.nextLabel}</Button>
            </StyledStepFooter>
          </Step>
        );
    }

}
